import React from "react";

const _HouseImgIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 418 418"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="418" height="418" rx="209" fill="backgroundColor" />
    <path
      d="M161 313H89V225C89 220.757 90.6857 216.687 93.6863 213.686C96.6869 210.686 100.757 209 105 209H161"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M257 209H313C317.243 209 321.313 210.686 324.314 213.686C327.314 216.687 329 220.757 329 225V313H257"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M225 271.006C224.718 267.033 222.879 263.333 219.882 260.71C216.886 258.087 212.975 256.754 209 257C205.025 256.754 201.114 258.087 198.118 260.71C195.121 263.333 193.282 267.033 193 271.006V313H225V271.006Z"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M209 137V73"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M209 73H251.667C253.081 73 254.438 73.5619 255.438 74.5621C256.438 75.5623 257 76.9188 257 78.3333V99.6667C257 101.081 256.438 102.438 255.438 103.438C254.438 104.438 253.081 105 251.667 105H209V73Z"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M193.352 185.352C193.352 189.502 195 193.482 197.935 196.417C200.869 199.351 204.849 201 209 201C213.15 201 217.13 199.351 220.064 196.417C222.999 193.482 224.648 189.502 224.648 185.352C224.648 181.202 222.999 177.222 220.064 174.287C217.13 171.352 213.15 169.704 209 169.704C204.849 169.704 200.869 171.352 197.935 174.287C195 177.222 193.352 181.202 193.352 185.352V185.352Z"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M257 183.592C256.812 171.049 251.649 159.094 242.648 150.357C233.647 141.619 221.543 136.815 209 137C196.457 136.815 184.353 141.619 175.352 150.357C166.351 159.094 161.188 171.049 161 183.592V313H257V183.592Z"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M121 241H129"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M121 281H129"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M289 241H297"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M289 281H297"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HouseImgIcon = React.memo(_HouseImgIcon);
